import React, { useState } from "react";
import { Stack } from "@mui/material";
import { Button, Box } from "@material-ui/core";
import BoardingCategoryTasksTable from "@components/table/BoardingCategoryTasksTable";
import BoardingCategoryModal from "@components/Modal/employees/CategoriesTasks/BoardingCategory";
import BoardingTasksModal from "@components/Modal/employees/CategoriesTasks/BoardingTasks";

const CategoryTaskLayout = ({ categoryData, transitionType }) => {
  const [categoryModal, setCategoryModal] = useState(false);
  const [tasksModal, setTasksModal] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);

  function handleEditTask(taskSelected) {
    setSelectedTask(taskSelected);
    setTasksModal(true);
  }
  function handleEditCategory(selectedCategory) {
    setSelectedCategory(selectedCategory);
    setCategoryModal(true);
  }

  return (
    <Box paddingRight={2} bgcolor="">
      <Stack
        direction="row"
        display="flex"
        justifyContent="center"
        alignItems="center"
        spacing={10}
      >
        <Button
          variant="contained"
          color="primary"
          onClick={() => setCategoryModal(true)}
        >
          Add Category
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setTasksModal(true)}
        >
          Add Task
        </Button>
      </Stack>

      {categoryData?.length > 0 && (
        <Box width="80%" margin="auto" marginTop={5} paddingBottom={5}>
          <BoardingCategoryTasksTable
            categoryiesData={categoryData}
            onEditTask={handleEditTask}
            onEditCategory={handleEditCategory}
            transitionType={transitionType}
          />
        </Box>
      )}

      <BoardingCategoryModal
        isUpdate={selectedCategory ? true : false}
        categoryModal={categoryModal}
        setCategoryModal={setCategoryModal}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        transitionType={transitionType}
      />
      <BoardingTasksModal
        isUpdate={selectedTask ? true : false}
        tasksModal={tasksModal}
        setTasksModal={setTasksModal}
        setSelectedTask={setSelectedTask}
        selectedTask={selectedTask}
        allCategories={categoryData}
        transitionType={transitionType}
      />
    </Box>
  );
};

export default CategoryTaskLayout;
